import { FieldOperationConfigFilesInput, UUID } from '@indigohive/cogfy-types'
import { PlusIcon, TrashIcon } from 'lucide-react'
import { useMemo } from 'react'
import { Button } from '../../../Button'
import { Select } from '../../../Select'
import { FormInputProps } from '../../types'
import { FileFormInputUploadButton } from './FileFormInputUploadButton'

export function FileFormInput (props: FormInputProps) {
  const multiple = props.schema.multiple ?? false

  const options = useMemo(
    () => {
      return [
        { label: 'Select a field or upload a file', value: '' },
        ...(props.fields ?? [])
          .filter(field => field.type === 'file')
          .map(field => ({ label: field.name, value: field.id }))
      ]
    },
    [props.fields]
  )

  const values: FieldOperationConfigFilesInput['files']['value'] = props.value?.type === 'fields'
    ? props.value.fields.value.map(item => ({ fieldId: item.id }))
    : props.value?.type === 'files'
      ? props.value.files.value
      : [{}]

  const handleAddClick = () => {
    props.onChange({
      type: 'files',
      files: {
        value: [...values, {}]
      }
    })
  }

  const handleDeleteClick = (index: number) => {
    const newValues = [...values]
    newValues.splice(index, 1)
    props.onChange({
      type: 'files',
      files: { value: newValues }
    })
  }

  return (
    <div className="flex flex-col gap-1">
      {values.map((value, index) => (
        <div key={index} className="flex gap-1 items-center">
          <div className="grow">
            {value.fileName && (
              <input
                className="input input-bordered input-sm input-disabled w-full"
                value={value.fileName}
              />
            )}
            {!value.fileName && (
              <Select
                size="md"
                value={value.fieldId ?? ''}
                onChange={event => {
                  const newValues = [...values]
                  newValues[index] = event.target.value
                    ? { fieldId: event.target.value as UUID }
                    : {}

                  props.onChange({
                    type: 'files',
                    files: { value: newValues }
                  })
                }}
                options={options}
              />
            )}
          </div>
          <FileFormInputUploadButton
            collectionId={props.collectionId}
            fieldId={props.fieldId}
            value={value}
            onDelete={() => {
              const newValues = [...values]
              newValues[index] = {}

              props.onChange({
                type: 'files',
                files: { value: newValues }
              })
            }}
            onSuccess={file => {
              const newValues = [...values]
              newValues[index] = { fileId: file.id, fileName: file.name }

              props.onChange({
                type: 'files',
                files: { value: newValues }
              })
            }}
          />
          {multiple && (
            <Button size="sm" square ghost onClick={() => handleDeleteClick(index)}>
              <TrashIcon size={16} />
            </Button>
          )}
        </div>
      ))}
      {multiple && (
        <div className="text-right">
          <Button className="mt-1" size="xs" onClick={handleAddClick}>
            <PlusIcon size={16} />
            Add field
          </Button>
        </div>
      )}
    </div>
  )
}
